import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {PrimaryGroupOverrideEditComponent} from '../../components/DomainDataEdit/PrimaryGroupOverrideEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-primarygroup-override-grid',
  templateUrl: './PrimaryGroupOverrideGrid.component.html'
})
export class PrimaryGroupOverrideGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(PrimaryGroupOverrideEditComponent) recordEditComponent: PrimaryGroupOverrideEditComponent;

    userInfo: ent.UserInfo;
    records: ent.PrimaryGroupOverride[];
    editedRecord: ent.PrimaryGroupOverride;
    cols: any[];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedRecord = new ent.PrimaryGroupOverride();
        //this.recordEditComponent.subtradeChannelDropdownComponent.load();
        this.recordEditComponent.paymentTermDropdownComponent.load();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'PrimaryGroup', header: 'Primary Group' },
            { field: 'KeyAccount.Name', header: 'Name' },
            { field: 'SalesOrg', header: 'Sales Org' },
            // { field: 'SubtradeChannel.Name', header: 'Subtrade Channel' },
            { field: 'PaymentTerm.Name', header: 'Payment Term' },
            { field: 'DSDBarcodeFlag', header: 'DSD Barcode Flag' },
            { field: 'StoreStampFlag', header: 'Store Stamp Flag' },
            { field: 'ACNNumber', header: 'ACN Number' },
            { field: 'EDIInboundProfileID', header: 'EDI Inbound Profile ID' },
            { field: 'DUNSNumber', header: 'DUNS Number' },
            { field: 'EDIVendorNumber', header: 'EDI Vendor Number' },
            { field: 'EDIOutboundProfileID', header: 'EDI Outbound Profile ID' },
            { field: 'DEXCommID', header: 'DEX Comm ID' },
            { field: 'DEXVersion', header: 'DEX Version' },
            { field: 'DEXEmpty', header: 'DEX Empty' },
            { field: 'PODSDNumberIndicator', header: 'PO DSD Number Indicator' },
            { field: 'Document', header: 'Document' },
            { field: 'Payer', header: 'Payer' },
            { field: 'AuthorizedMaterialList', header: 'AML' },
            // { field: 'DrPepperAuthorizedMaterialList', header: 'Dr Pepper AML' },
            { field: 'LocCode', header: 'LocCode' },
            { field: 'MinimumOrderQuantityFeeCode', header: 'Minimum Order Quantity Fee Code' },
            { field: 'ZNPartnerRequired', header: 'ZN Partner Required' },
            { field: 'IEI_Eligibility', header: 'IEI Eligibility' },
            { field: 'AccountingClerk', header: 'Accounting Clerk' },
            { field: 'PaymentEligibility', header: 'Payment Eligibility' },
            { field: 'PaymentOptions', header: 'Payment Options' },
            { field: 'MyCokePermissions', header: 'MyCoke Permissions' },
            { field: 'Inactive', header: 'Inactive' }
        ];
    }

    onAddClick(event: any){
        this.editedRecord = new ent.PrimaryGroupOverride();
        //this.recordEditComponent.subtradeChannelDropdownComponent.value = null;
        this.recordEditComponent.paymentTermDropdownComponent.value = null;
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, record: ent.PrimaryGroupOverride){
        this.editedRecord = record;
        //this.recordEditComponent.subtradeChannelDropdownComponent.value = record.SubtradeChannelID;
        this.recordEditComponent.paymentTermDropdownComponent.value = record.PaymentTermID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SavePrimaryGroupOverrideRequest = {PrimaryGroupOverride: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.savePrimaryGroupOverride(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
    
    onSearchClick(event: any){
        this.blockComponent.blocked = true;
        this.domainDataService.getPrimaryGroupOverrides().subscribe(x=>{
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
}